/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/interactive-supports-focus */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';

import * as S from './styles';

export default class Handle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dragging: false,
    };
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.positionData.position !== nextProps.positionData.position) {
      return true;
    }

    if (this.props.dragging !== nextProps.dragging) {
      return true;
    }

    return false;
  }

  static getPointerX(event) {
    if (event.clientX) {
      return event.clientX;
    }

    return event.touches ? event.touches[0].clientX : null;
  }

  startDrag = event => {
    this.setState({
      dragging: true,
    });
    // Prevent default to get rid of the "issue" where the user might select text when dragging
    event.preventDefault();

    const sliderWidth = this.props.getSliderWidth();
    this.pixelSize = 100 / sliderWidth;

    this.initialPointerX = Handle.getPointerX(event);
    this.currentPointerX = this.initialPointerX;
    this.initialPosition = this.props.positionData.position * 100;

    const throttledDragHelper = throttle(this.dragPositionHelper, 1000 / 60);
    this.dragHelper = moveEvent => {
      // this is necessary because if the preventDefault is throttled
      // the page will be able to be panned when dragging a handle. (touch only)
      // UPDATE: might not be necessary if touch-action works as advertised.
      moveEvent.preventDefault();
      throttledDragHelper(moveEvent);
    };

    this.props.startDragging(() => {
      requestAnimationFrame(this.handleDrag);
      this.addMoveEventListeners();
      this.removeEndEventListeners(); // make sure any dangling events are removed before adding new
      this.addEndEventListeners();
    });
  };

  handleDrag = () => {
    if (!this.props.dragging) {
      return;
    }

    // if no movement, skip calculation, wait for next frame
    if (this.currentPointerX === this.prevPointerX) {
      requestAnimationFrame(this.handleDrag);
      return;
    }
    const deltaX = this.currentPointerX - this.initialPointerX;

    const percentageMoved = deltaX * this.pixelSize;
    const positionPercentage = this.initialPosition + percentageMoved;
    this.prevPointerX = this.currentPointerX;

    this.props.updateSlider({
      id: this.props.id,
      position: positionPercentage,
    });
    if (this.props.dragging) {
      requestAnimationFrame(this.handleDrag);
    }
  };

  stopDrag = () => {
    this.setState({
      dragging: false,
    });
    this.removeMoveEventListeners();
    this.removeEndEventListeners();

    this.initialPointerX = null;
    this.initialPosition = null;
    this.deltaX = null;
    this.props.stopDragging();
  };

  dragPositionHelper = event => {
    this.currentPointerX = Handle.getPointerX(event);
  };

  addMoveEventListeners() {
    ['touchmove', 'mousemove'].forEach(eventName => {
      document.addEventListener(eventName, this.dragHelper);
    });
  }

  removeMoveEventListeners() {
    ['touchmove', 'mousemove'].forEach(eventName => {
      document.removeEventListener(eventName, this.dragHelper);
    });
  }

  addEndEventListeners() {
    ['touchend', 'mouseup'].forEach(eventName => {
      document.addEventListener(eventName, this.stopDrag);
    });
  }

  removeEndEventListeners() {
    ['touchend', 'mouseup'].forEach(eventName => {
      document.removeEventListener(eventName, this.stopDrag);
    });
  }

  render() {
    return (
      <S.Handle
        direction={this.props.id}
        onMouseDown={this.startDrag}
        onTouchStart={this.startDrag}
        dragging={this.state.dragging}
        style={{
          left: `${this.props.positionData.position * 100}%`,
        }}
      >
        <S.HandleDot
          selected={this.props.selected}
          dragging={this.state.dragging}
        />
      </S.Handle>
    );
  }
}

Handle.defaultProps = {
  selected: false,
};

Handle.propTypes = {
  id: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  positionData: PropTypes.shape({
    fill: PropTypes.number,
    position: PropTypes.number,
    section: PropTypes.number,
  }).isRequired,
  startDragging: PropTypes.func.isRequired,
  stopDragging: PropTypes.func.isRequired,
  getSliderWidth: PropTypes.func.isRequired,
  updateSlider: PropTypes.func.isRequired,
  dragging: PropTypes.bool.isRequired,
};
